export const INVOICING_SETTINGS_CUSTOMISATION =
  'invoicing-settings-customisation'
